import moment from 'moment';
import 'moment/locale/nl';
import { pageLang } from './app-storage';

export default function loadMoment(): void {
    moment.locale(pageLang);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/moment-utils.ts